import { render, staticRenderFns } from "./CompGeneralDropdownIcon.vue?vue&type=template&id=25f64a1c"
import script from "./CompGeneralDropdownIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralDropdownIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports